/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BusinessErrorCode {
  NO_ACTIVE_SUBSCRIPTION = "NO_ACTIVE_SUBSCRIPTION",
  NO_SUBSCRIPTION = "NO_SUBSCRIPTION",
  PAYMENT_METHOD_NOT_FOUND = "PAYMENT_METHOD_NOT_FOUND",
  SESSION_NOT_FOUND = "SESSION_NOT_FOUND",
  SUBSCRIPTION_PLAN_NOT_FOUND = "SUBSCRIPTION_PLAN_NOT_FOUND",
  USER_ADDRESS_NOT_FOUND = "USER_ADDRESS_NOT_FOUND",
}

export enum CartErrorCode {
  CART_NOT_FOUND = "CART_NOT_FOUND",
  OUT_OF_STOCK = "OUT_OF_STOCK",
  PURCHASE_ITEM_NOT_FOUND = "PURCHASE_ITEM_NOT_FOUND",
  QUEUE_ITEM_NOT_FOUND = "QUEUE_ITEM_NOT_FOUND",
  SUBSCRIPTION_PLAN_NOT_FOUND = "SUBSCRIPTION_PLAN_NOT_FOUND",
  TRADING_ITEM_NOT_FOUND = "TRADING_ITEM_NOT_FOUND",
}

export enum ChangePlanErrorCode {
  NOT_ALLOWED_PLAN = "NOT_ALLOWED_PLAN",
  SAME_PLAN = "SAME_PLAN",
}

export enum CouponErrorCode {
  ACTIVATED = "ACTIVATED",
  ALREADY_REDEEMED_ON_ACCOUNT = "ALREADY_REDEEMED_ON_ACCOUNT",
  COUPON_HAS_LOWER_VALUE = "COUPON_HAS_LOWER_VALUE",
  DISABLED = "DISABLED",
  MAXED_OUT = "MAXED_OUT",
  NOT_ACTIVE = "NOT_ACTIVE",
  NOT_APPLICABLE_FOR_PLAN = "NOT_APPLICABLE_FOR_PLAN",
  NOT_FOUND = "NOT_FOUND",
  ONLY_FIRST_SUBSCRIBERS = "ONLY_FIRST_SUBSCRIBERS",
  ONLY_NEW_SUBSCRIBERS = "ONLY_NEW_SUBSCRIBERS",
  PERIOD_ENDED = "PERIOD_ENDED",
  UNKNOWN = "UNKNOWN",
}

export enum CouponType {
  MARKETING = "MARKETING",
  ORDER = "ORDER",
}

export enum EcommercePriceRulesAndOffers {
  TOSSIN = "TOSSIN",
}

export enum GiftCardType {
  DIGITAL = "DIGITAL",
  PHYSICAL = "PHYSICAL",
}

export enum InitialSubscriptionPlan {
  MONTHLY = "MONTHLY",
  MONTHLY_2PCS = "MONTHLY_2PCS",
  MONTHLY_3PCS = "MONTHLY_3PCS",
}

export enum OperationSessionStatus {
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  NEW = "NEW",
  SUCCESS = "SUCCESS",
}

export enum OriginType {
  LANDING = "LANDING",
  MANUAL = "MANUAL",
  SITE = "SITE",
}

export enum PaymentGatewayErrorCode {
  PURCHASE_TRANSACTION_ERROR = "PURCHASE_TRANSACTION_ERROR",
  SUBSCRIPTION_RESUME_ERROR = "SUBSCRIPTION_RESUME_ERROR",
}

export enum PaymentMethodType {
  AMAZON_PAY = "AMAZON_PAY",
  APPLE_PAY = "APPLE_PAY",
  CREDIT_CARD = "CREDIT_CARD",
  PAYPAL = "PAYPAL",
}

export enum PurchaseBeginErrorCode {
  CART_IS_EMPTY = "CART_IS_EMPTY",
  ECOMMERCE_NOT_FOUND = "ECOMMERCE_NOT_FOUND",
  QUEUE_ITEMS_NOT_FOUND = "QUEUE_ITEMS_NOT_FOUND",
  SUBSCRIPTION_NOT_FOUND = "SUBSCRIPTION_NOT_FOUND",
}

export enum PurchaseCommitErrorCode {
  ALREADY_PROCESSED = "ALREADY_PROCESSED",
  PURCHASE_ITEMS_NOT_FOUND = "PURCHASE_ITEMS_NOT_FOUND",
}

export enum PurchaseErrorCode {
  ALREADY_ACTIVE_SUBSCRIPTION = "ALREADY_ACTIVE_SUBSCRIPTION",
  AMAZON_BAID_TAKEN = "AMAZON_BAID_TAKEN",
  EXTERNAL_NETWORK_ISSUE = "EXTERNAL_NETWORK_ISSUE",
  INVALID_ADDRESS = "INVALID_ADDRESS",
  INVALID_TOKEN = "INVALID_TOKEN",
  PRIMARY_METHOD_NOT_FOUND = "PRIMARY_METHOD_NOT_FOUND",
  TAXABLE_ADDRESS_REQUIRED = "TAXABLE_ADDRESS_REQUIRED",
  UNKNOWN = "UNKNOWN",
  WRONG_PLAN_CODE = "WRONG_PLAN_CODE",
  WRONG_TOKEN = "WRONG_TOKEN",
}

export enum PurchaseLevel {
  ALL = "ALL",
  BUY_QUEUE = "BUY_QUEUE",
  ECOMMERCE_AND_SUBSCRIPTION = "ECOMMERCE_AND_SUBSCRIPTION",
  ECOMMERCE_ONLY = "ECOMMERCE_ONLY",
  GIFT_CARD_ONLY = "GIFT_CARD_ONLY",
  GIFT_SUBSCRIPTION_ONLY = "GIFT_SUBSCRIPTION_ONLY",
  SUBSCRIPTION_ONLY = "SUBSCRIPTION_ONLY",
}

export enum RefundDecision {
  RECEIVE = "RECEIVE",
  REFUND = "REFUND",
}

export enum RefundStatus {
  AVAILABLE = "AVAILABLE",
  AVAILABLE_NEW_SUBSCRIBER = "AVAILABLE_NEW_SUBSCRIBER",
  AVAILABLE_PENDING_CHARGE = "AVAILABLE_PENDING_CHARGE",
  AVAILABLE_UPCHARGE = "AVAILABLE_UPCHARGE",
  NOT_REFUNDABLE = "NOT_REFUNDABLE",
}

/**
 * type of futher to refund operation
 */
export enum RefundTransactionType {
  PAUSE = "PAUSE",
  SKIP = "SKIP",
  UNSUBSCRIBE = "UNSUBSCRIBE",
}

export enum SecurityErrorCode {
  ACCESS_DENIED = "ACCESS_DENIED",
  NOT_AUTHENTICATED = "NOT_AUTHENTICATED",
}

export enum ServerErrorCode {
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
}

export enum SkipDuration {
  FOREVER = "FOREVER",
  MONTH_1 = "MONTH_1",
  MONTH_2 = "MONTH_2",
  MONTH_3 = "MONTH_3",
}

export enum SubscribedErrorCode {
  ALREADY_SUBSCRIBED = "ALREADY_SUBSCRIBED",
}

export enum UnskipErrorCode {
  NOT_UNSKIPPABLE = "NOT_UNSKIPPABLE",
}

export enum UnsubscribeErrorCode {
  ALREADY_SCHEDULED_FOR_CANCELLATION = "ALREADY_SCHEDULED_FOR_CANCELLATION",
}

export enum UnsubscribeReasonType {
  ANOTHER_SUBSCRIPTION = "ANOTHER_SUBSCRIPTION",
  BAD_PERFUME = "BAD_PERFUME",
  BAD_PRODUCT = "BAD_PRODUCT",
  BILLED_INCORRECTLY = "BILLED_INCORRECTLY",
  CUSTOMER_SERVICE = "CUSTOMER_SERVICE",
  DAMAGED_PRODUCT = "DAMAGED_PRODUCT",
  DISCONTINUED = "DISCONTINUED",
  FINANCIAL_COMMITMENT = "FINANCIAL_COMMITMENT",
  FINANCIAL_VALUE = "FINANCIAL_VALUE",
  FRAGRANCE_OPTIONS = "FRAGRANCE_OPTIONS",
  FULL_SIZE_BOTTLE = "FULL_SIZE_BOTTLE",
  MANY_PERFUMES = "MANY_PERFUMES",
  ONE_PERFUME = "ONE_PERFUME",
  OUT_OF_BUDGET = "OUT_OF_BUDGET",
  SHIPPING_ISSUES = "SHIPPING_ISSUES",
  TOO_EXPENSIVE = "TOO_EXPENSIVE",
  WEBSITE_ISSUES = "WEBSITE_ISSUES",
}

export enum ValidationErrorCode {
  ENTITY_NOT_FOUND = "ENTITY_NOT_FOUND",
  NOT_VALID = "NOT_VALID",
}

export interface AddressInput {
  country: string;
  postalCode: string;
  region: string;
  city: string;
  street1: string;
  street2?: string | null;
  phone?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export interface AnalyticsMetadataInput {
  placement?: string | null;
  tab?: string | null;
}

export interface CartClearInput {
  metadata?: AnalyticsMetadataInput | null;
}

export interface CartOperationInput {
  subscriptionItem?: SubscriptionItemInput | null;
  productItems?: ProductItemInput[] | null;
  giftCardItem?: GiftCardItemInput | null;
  giftSubscriptionItem?: GiftSubscriptionItemInput | null;
  pickedProductItems?: PickedProductItemInput[] | null;
  queueItems?: QueueItemInput[] | null;
  metadata?: AnalyticsMetadataInput | null;
}

export interface CouponApplyInput {
  couponCode: string;
  origin?: OriginType | null;
  metadata?: AnalyticsMetadataInput | null;
  validateOnly?: boolean | null;
}

export interface GiftCardItemInput {
  productId: any;
  type: GiftCardType;
  recipient?: GiftRecipientInput | null;
}

export interface GiftRecipientInput {
  name: string;
  email: string;
  message: string;
  date?: any | null;
}

export interface GiftSubscriptionItemInput {
  months: number;
  recipient?: GiftRecipientInput | null;
}

export interface PaymentMethodBeginInput {
  paymentMethod: PaymentMethodType;
  billing?: AddressInput | null;
  primary: boolean;
  couponCode?: string | null;
  metadata?: AnalyticsMetadataInput | null;
}

export interface PaymentMethodCommitInput {
  sessionId: any;
  token: Token;
}

export interface PickedProductItemInput {
  productId: any;
}

export interface PixelDataInput {
  name: string;
}

export interface PlansInquiryInput {
  productsPerPeriod?: number | null;
  billingPeriod?: number | null;
  shippingPeriod?: number | null;
  couponCode?: string | null;
}

export interface ProductItemInput {
  productLineItemId: any;
  quantity?: number | null;
  offer?: EcommercePriceRulesAndOffers | null;
}

export interface PurchaseBeginInput {
  paymentMethod: PaymentMethodType;
  shipping: AddressInput;
  billing?: AddressInput | null;
  purchaseLevel?: PurchaseLevel | null;
}

export interface PurchaseCommitInput {
  sessionId: any;
  token: Token;
  shipping?: AddressInput | null;
}

export interface PurchaseFailedInput {
  sessionId: any;
  purchaseErrorCode?: string | null;
  purchaseErrorMessage?: string | null;
}

export interface PurchaseInquiryInput {
  initialSubscriptionPlan?: InitialSubscriptionPlan | null;
  shipping?: AddressInput | null;
  purchaseLevel?: PurchaseLevel | null;
}

export interface PurchaseOneClickInput {
  paymentMethodId: string;
  purchaseLevel?: PurchaseLevel | null;
}

export interface PurchaseSessionInput {
  sessionId: any;
}

export interface QueueItemInput {
  queueItemId: any;
}

export interface RefundInquiryInput {
  transactionType: RefundTransactionType;
}

export interface SubscriptionChangePlanInput {
  targetPlan: string;
  paymentMethodId?: string | null;
  refundDecision?: RefundDecision | null;
  metadata?: AnalyticsMetadataInput | null;
}

export interface SubscriptionChangePlanInquiryInput {
  targetPlan: string;
}

export interface SubscriptionChangePlanSessionInput {
  sessionId: any;
}

export interface SubscriptionItemInput {
  plan: InitialSubscriptionPlan;
  caseSubscription?: boolean | null;
}

export interface SubscriptionResubscribeInput {
  couponCode?: string | null;
  plan?: string | null;
  paymentMethodId?: string | null;
  metadata?: AnalyticsMetadataInput | null;
}

export interface SubscriptionSkipInput {
  duration: SkipDuration;
  refundDecision?: RefundDecision | null;
  remind?: boolean | null;
}

export interface SubscriptionUnskipInput {
  couponCode?: string | null;
  metadata?: AnalyticsMetadataInput | null;
}

export interface SubscriptionUnsubscribeInput {
  refundDecision?: RefundDecision | null;
  reason?: UnsubscribeReasonType | null;
  comment?: string | null;
}

/**
 * This token is obtained from Recurly JS client / Amazon lib
 */
export interface Token {
  paymentMethod: PaymentMethodType;
  tokenId: string;
  threeDSecureActionTokenId?: string | null;
}

export interface UserPaymentProfileInput {
  token: Token;
  accessToken?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
